// import React from 'react';
// import './Values.css';
// import AllIntroTemplate from "../../components/AllIntroTemplate/AllIntroTemplate.js";
// import AllValues from "../../components/AllValues/AllValues.js";
// import ContentModel from "../../components/ContentModel/ContentModel.js";
// import { getStoredData } from "../../json/fetchData.js";

// const Values = () => {
//   const totalData = getStoredData();
//   const data = totalData ? totalData["20"] : {};
//   return (
//     <div>
//       <AllIntroTemplate 
//         image={data.Image} 
//         title={data.Title} 
//         page={totalData ? totalData["0"] : {}}
//       />
//       <ContentModel data={totalData ? totalData["20"] : {}}/>
//       <AllValues values={data.values}/>
//     </div>
//   );
// };

// export default Values;


import React, { lazy, Suspense } from 'react';
import './Values.css';
import { getStoredData } from "../../json/fetchData.js";
// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));
const AllValues = lazy(() => import("../../components/AllValues/AllValues.js"));


const Values = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["20"] : {};

  return (
    <div>
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate 
          image={data.Image} 
          title={data.Title} 
          page={totalData ? totalData["0"] : {}}
        />
      </Suspense>

      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={totalData ? totalData["20"] : {}} />
      </Suspense>

      <Suspense fallback={<p>Loading values...</p>}>
        <AllValues values={data.values} />
      </Suspense>
    </div>
  );
};

export default Values;
